module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chap"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Editor’s Acknowledgments")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('i', [_c('span', {
    staticClass: "big"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("THNOGRAPHIC")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCOUNTERS IN")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SRAEL")])]), _vm._v(" emerged from a series of conversations that I had with Tamir Erez and Dafna Shir-Vertesh about the paucity of written texts dealing with fieldwork in Israel, and how we might remedy that lack. At first my aim was to compile a Hebrew language collection for use in Israeli universities. But Tamir and Dafna had a better idea. They insisted on an English language volume that would address an international audience of anthropologists—students, teachers, generalists, and specialists. I thank Tamir and Dafna for their wisdom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rebecca Tolen of Indiana University Press embraced this project and nurtured it at every stage. It has been wonderful to work with a sponsoring editor who is an experienced anthropologist as well as extraordinarily skilled in the nuances of the English language.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Along with my Introduction, this volume consists of eleven original essays by eleven remarkable anthropologists. Some of the contributors are at the very beginning of their academic careers; others are well established, while most are somewhere in between. It has been a great pleasure to work with all of them. My only regret is that submissions by Don Handelman, Smadar Lavie, Amalia Sa’ar, and Dafna Shir-Vertesh could not be included in this book. I look forward to seeing their essays published elsewhere.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I am grateful to those of my teachers, colleagues and students who have in some way inspired this volume. Most of all, it has benefitted from the brilliance of Shmuel Ben-Dor and Tania Forte, to whose blessed memories this book is dedicated.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a324741","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_ack.vue
// module id = 72
// module chunks = 0